<div class="legend-row">
    <div class="legend-item">
        <div class="box no-results"></div> <span class="legend-text text--medium">{{ 'map.legend.no_data' | translate }}</span>
    </div>
    <div class="legend-item">
        <div class="box partial-result"></div> <span class="legend-text text--medium">{{ 'map.legend.preliminary' | translate }}</span>
    </div>
</div>
<div class="legend-row">
    <div class="legend-item">
        <div class="box preliminary-result"></div> <span class="legend-text text--medium">{{ 'map.legend.election_night' | translate }}</span>
    </div>
    <div class="legend-item">
        <div class="box final-result"></div> <span class="legend-text text--medium">{{ 'map.legend.final' | translate }}</span>
    </div>
</div>
